import * as React from 'react';
import classNames from 'classnames';
import { withStyles, Theme, createStyles, WithStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { Person } from '@material-ui/icons'
import PeopleIcon from '@material-ui/icons/People';
import BarChartIcon from '@material-ui/icons/BarChart';
import { SettingsOutlined } from '@material-ui/icons'
import { LinearProgress, Menu, MenuItem, Button, Dialog, DialogTitle, DialogContent, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import strings from 'src/strings';
import { withRouter, RouteComponentProps } from 'react-router';
import { withToast, WithToast } from '../HOC/Toast';
import { WithUser } from '../HOC/User';
import { User } from 'src/api';
import logo from '../../assets/logo-dark.png'
import ComponentCommunicator from '../ComponentCommunicator';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faProjectDiagram } from '@fortawesome/free-solid-svg-icons'

interface HeaderProps extends WithStyles<typeof styles>, WithToast, WithUser<true>, RouteComponentProps<{ subPage: string }> {
    loading: boolean;
}

interface HeaderState {
    left_menu_open: boolean;
    profileMenuAnchorElem?: any,
    user: User
    loading: boolean
}
const DRAWER_TTRANSITION_DURATION = 200
const DID_RESIZE = "DID_RESIZE"
class Header extends React.Component<HeaderProps, HeaderState> {

    constructor(props: HeaderProps) {
        super(props);
        this.state = {
            left_menu_open: localStorage['left_menu_open'] != 'false',
            user: this.props.user,
            loading: false
        }
    }

    handleDrawerOpen = () => {
        localStorage['left_menu_open'] = 'true'
        this.setState({ left_menu_open: true }, () => {
            setTimeout(() => {
                ComponentCommunicator.instance().emit(DID_RESIZE)
            }, DRAWER_TTRANSITION_DURATION + 10)
        });
    };

    handleDrawerClose = () => {
        localStorage['left_menu_open'] = 'false'
        this.setState({ left_menu_open: false }, () => {
            setTimeout(() => {
                ComponentCommunicator.instance().emit(DID_RESIZE)
            }, DRAWER_TTRANSITION_DURATION + 10)
        });
    };

    public render() {
        const { classes } = this.props
        const { profileMenuAnchorElem } = this.state;
        return (<>
            <CssBaseline />
            <AppBar
                position="absolute"
                className={classNames(classes.appBar, this.state.left_menu_open && classes.appBarShift)}>
                {(this.props.loading || this.state.loading) && <LinearProgress className={classes.loader} color="secondary" />}
                <Toolbar disableGutters={!this.state.left_menu_open} className={classes.toolbar}>
                    <IconButton
                        color="inherit"
                        aria-label="Open drawer"
                        onClick={this.handleDrawerOpen}
                        className={classNames(
                            classes.menuButton,
                            this.state.left_menu_open && classes.menuButtonHidden,
                        )}>
                        <MenuIcon />
                    </IconButton>
                    <div className={classes.logoContainer}>
                        <img src={logo} className={classes.logo} />
                    </div>
                    <Button color="inherit" onClick={(e) => this.setState({ profileMenuAnchorElem: e.currentTarget })}>
                        {this.state.user.email!}
                        <Person className={classes.profileIcon} />
                    </Button>
                    <Menu
                        id="simple-menu"
                        anchorEl={profileMenuAnchorElem}
                        open={Boolean(profileMenuAnchorElem)}
                        onClose={(e) => { this.setState({ profileMenuAnchorElem: undefined }) }}>
                        <MenuItem onClick={(e) => this.props.history.push('/app/settings')}>{strings.settings}</MenuItem>
                        <MenuItem onClick={(e) => this.props.history.push('/logout')}>{strings.logout}</MenuItem>
                    </Menu>
                </Toolbar>
            </AppBar>
            <Drawer
                variant="permanent"
                classes={{
                    paper: classNames(classes.drawerPaper, !this.state.left_menu_open && classes.drawerPaperClose),
                }}
                open={this.state.left_menu_open}>
                <div className={classes.toolbarIcon}>
                    <IconButton onClick={this.handleDrawerClose}>
                        <ChevronLeftIcon />
                    </IconButton>
                </div>
                <Divider />
                <List>
                    <ListItem button onClick={() => this.props.history.push('/app/reports')}>
                        <ListItemIcon>
                            <BarChartIcon />
                        </ListItemIcon>
                        <ListItemText primary={strings.reports} />
                    </ListItem>
                    <ListItem button onClick={() => this.props.history.push('/app/agency-report')}>
                        <ListItemIcon>
                            <FontAwesomeIcon icon={faProjectDiagram} />
                        </ListItemIcon>
                        <ListItemText primary={strings.agencyReport} />
                    </ListItem>
                    <ListItem button onClick={() => this.props.history.push('/app/clients')}>
                        <ListItemIcon>
                            <PeopleIcon />
                        </ListItemIcon>
                        <ListItemText primary={strings.clients} />
                    </ListItem>
                    <ListItem button onClick={() => this.props.history.push('/app/settings')}>
                        <ListItemIcon>
                            <SettingsOutlined />
                        </ListItemIcon>
                        <ListItemText primary={strings.settings} />
                    </ListItem>
                </List>
                {/*<Divider />
                <List>{secondaryListItems}</List>*/}
            </Drawer>
        </>
        )
    }
}
const drawerWidth = 240;

const styles = (theme: Theme) => createStyles({
    loader: {
        flexGrow: 1
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        backgroundColor: '#2c303a',
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginLeft: 12,
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    logoContainer: {
        flex: 1,
    },
    logo: {
        maxHeight: '40px'
    },
    profileIcon: {
        marginLeft: theme.spacing()
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    chartContainer: {
        marginLeft: -22,
    },
    tableContainer: {
        height: 320,
    },
    h5: {
        marginBottom: theme.spacing(2),
    },
});

export default ((withRouter(withToast(withStyles(styles)(Header)))) as React.ComponentClass<{ user: User, loading: boolean }>)


// WEBPACK FOOTER //
// ./src/components/Header/Header.tsx